import { render, staticRenderFns } from "./form-queries-list-item.vue?vue&type=template&id=4987c862&scoped=true&"
import script from "./form-queries-list-item.vue?vue&type=script&lang=js&"
export * from "./form-queries-list-item.vue?vue&type=script&lang=js&"
import style0 from "./form-queries-list-item.vue?vue&type=style&index=0&id=4987c862&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4987c862",
  null
  
)

component.options.__file = "form-queries-list-item.vue"
export default component.exports